import React from 'react';

const ReservationTrends = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="bg-white shadow rounded-lg p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Reservation Trends</h3>
        <p className="text-sm text-gray-500">No data available</p>
      </div>
    );
  }

  // Find max value for scaling
  const maxValue = Math.max(...data.map(d => d.count));
  const chartHeight = 200;

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Reservation Trends</h3>

      {/* Simple Bar Chart */}
      <div className="mt-4">
        <div className="flex items-end justify-between space-x-2" style={{ height: chartHeight }}>
          {data.map((item, index) => {
            const height = maxValue > 0 ? (item.count / maxValue) * (chartHeight - 40) : 0;

            return (
              <div key={index} className="flex-1 flex flex-col items-center justify-end group">
                <div className="relative flex-1 flex items-end w-full">
                  <div className="relative w-full">
                    {/* Tooltip on hover */}
                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10">
                      {item.count} reservations
                    </div>

                    {/* Bar */}
                    <div
                      className="w-full bg-blue-500 rounded-t hover:bg-blue-600 transition-colors cursor-pointer"
                      style={{ height: `${height}px` }}
                    />
                  </div>
                </div>

                {/* Label */}
                <div className="text-xs text-gray-600 mt-2 text-center">
                  {new Date(item.date).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric'
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ReservationTrends;
